import $ from 'jquery';

$(function () {
    const form = $('#id_question_form');

    $('input[name="captcha_1"]', form).addClass('form-control').css('display', 'block');
    $('img.captcha').css('margin', '20px 0');
    form.validate();
});


// WEBPACK FOOTER //
// ./js/appeals/index.js